const bookingHeaderReducer = (
    state = {
      data: [],
    },
    action: {
      type: "SET_BOOKING_HEADER_LIST";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "SET_BOOKING_HEADER_LIST":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default bookingHeaderReducer;
  